var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { gql, useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { mapSpaceStateToMapType, toISOStringWithoutMilliseconds, } from '../utils';
var USE_SPACE_STATE_QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query MapSpaceStateForLevel(\n    $levelId: ID!\n    $intervalInMinutes: Int\n    $startTime: Date\n    $meetingDurationInMinutes: Int\n  ) {\n    getLevelById(id: $levelId) {\n      id\n      name\n      levelLocation {\n        id\n        name\n      }\n      spaces {\n        id\n        name\n        type\n        capacity\n        image\n        isDisabled\n        isAccessible\n        isManaged\n        locationId\n        amenities {\n          id\n          name\n          amenityId\n          quantity\n        }\n        calendar {\n          calendarId\n        }\n        scheduleConfiguration\n        windowedAvailability(\n          numberOfWindows: 1\n          intervalInMinutes: $intervalInMinutes\n          startTime: $startTime\n          meetingDurationInMinutes: $meetingDurationInMinutes\n        ) {\n          status\n          unbookableReasons\n          isConfirmed\n          start\n          end\n        }\n      }\n    }\n  }\n"], ["\n  query MapSpaceStateForLevel(\n    $levelId: ID!\n    $intervalInMinutes: Int\n    $startTime: Date\n    $meetingDurationInMinutes: Int\n  ) {\n    getLevelById(id: $levelId) {\n      id\n      name\n      levelLocation {\n        id\n        name\n      }\n      spaces {\n        id\n        name\n        type\n        capacity\n        image\n        isDisabled\n        isAccessible\n        isManaged\n        locationId\n        amenities {\n          id\n          name\n          amenityId\n          quantity\n        }\n        calendar {\n          calendarId\n        }\n        scheduleConfiguration\n        windowedAvailability(\n          numberOfWindows: 1\n          intervalInMinutes: $intervalInMinutes\n          startTime: $startTime\n          meetingDurationInMinutes: $meetingDurationInMinutes\n        ) {\n          status\n          unbookableReasons\n          isConfirmed\n          start\n          end\n        }\n      }\n    }\n  }\n"])));
/* @TODO Copy pasta of apps/schedule/src/components/Map/Spaces/useSpaceStateQuery.ts
 * refactor coming in subsequent PRs as needed
 */
export var useSpaceStateQuery = function (_a) {
    var _b, _c;
    var levelId = _a.levelId, startTime = _a.startTime, endTime = _a.endTime, spaceFilter = _a.spaceFilter, skip = _a.skip, tenantId = _a.tenantId;
    var meetingDurationInMinutes = endTime.diff(startTime, 'minutes');
    var result = useQuery(USE_SPACE_STATE_QUERY, {
        skip: skip || !tenantId || !levelId,
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
        variables: {
            levelId: levelId || '',
            startTime: toISOStringWithoutMilliseconds(startTime),
            intervalInMinutes: meetingDurationInMinutes,
            meetingDurationInMinutes: meetingDurationInMinutes,
        },
    });
    var availabilityStateById = useMemo(function () {
        var _a, _b;
        var spaces = ((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.getLevelById) === null || _b === void 0 ? void 0 : _b.spaces) || [];
        return spaces.reduce(function (acc, space) {
            var meetsFilterCriteria = spaceFilter(space);
            acc[space.id] = mapSpaceStateToMapType(space, meetsFilterCriteria);
            return acc;
        }, {});
    }, [(_c = (_b = result.data) === null || _b === void 0 ? void 0 : _b.getLevelById) === null || _c === void 0 ? void 0 : _c.spaces, spaceFilter]);
    var availabilityStates = useMemo(function () {
        return Object.entries(availabilityStateById).reduce(function (acc, _a) {
            var _b = __read(_a, 2), stringId = _b[0], state = _b[1];
            var id = parseInt(stringId, 10);
            Object.entries(state).forEach(function (_a) {
                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                if (value) {
                    acc["".concat(key, "Ids")].push(id);
                }
            });
            return acc;
        }, {
            bookedIds: [],
            inUseIds: [],
            restrictedIds: [],
            warningIds: [],
            disabledIds: [],
            focusedIds: [],
            availableIds: [],
            selectedIds: [],
            reducedIds: [],
        });
    }, [availabilityStateById]);
    return __assign(__assign({}, result), { availabilityStates: availabilityStates, availabilityStateById: availabilityStateById });
};
var templateObject_1;
